module.exports = __webpack_public_path__ + "static/media/about.a4be1337.jpg";